import dayjs from "dayjs";
export const standardDateFormat = (date) => {
  // Convert dayjs object to JS Date if needed
  const jsDate = dayjs.isDayjs(date) ? date.toDate() : date;

  let month = jsDate.getMonth() + 1;
  month = month < 10 ? `0${month}` : month;

  let day = jsDate.getDate();
  day = day < 10 ? `0${day}` : day;
  const dateString = `${jsDate.getFullYear()}-${month}-${day}`;
  return dateString;
};

export const getDayOfMonthSuffix = (dayOfMonth) => {
  if (dayOfMonth >= 11 && dayOfMonth <= 13) {
    return "th";
  }
  switch (dayOfMonth % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export function getMostRecentSunday(date = null) {
  const targetDate = date ?? dayjs();
  const dayOfWeek = targetDate.day(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  return targetDate.subtract(dayOfWeek, "day").startOf("day");
}

export const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
